import { ReactNode, useState } from "react";
import { Alert, Card, Col, Collapse, Row, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronUp, mdiClipboardPulseOutline, mdiPulse, mdiSquareRounded } from "@mdi/js";
import { getSaudeIcon, ordenarPorSaude } from "../../utils/saude";
import { useGetGruposGrupo } from "../../config/swagger";
import { formatarTempoChecagem } from "../../utils/tempo";

type DashboardEmbedCardProps = {
	id?: number;
	title: string;
	dataUltimaChecagem?: string | ReactNode;
	monitoresBads?: string | null;
	monitoresRegulares?: string | null;
	monitoresGoods?: string | null;
	saude?: string | null;
	loading?: boolean;
};

export default function DashboardEmbedCard(props: DashboardEmbedCardProps) {
	const [expanded, setExpanded] = useState(false);

	const queryGrupo = useGetGruposGrupo({ id: props.id || 0 }, { query: { enabled: expanded && !!props.id, refetchInterval: 60 * 1000 } });

	function handleClick() {
		setExpanded(!expanded);
	}

	let skeletonButton = "";
	if (props.loading) {
		skeletonButton = "skeleton skeleton-button";
	}

	return (
		<Card className="border-0 mb-4 shadow">
			<Card.Body className="py-2" onClick={handleClick} style={{ cursor: "pointer" }}>
				<Row>
					<Col md={"auto"} className="d-flex align-items-center justify-content-center" style={{ height: 60 }}>
						<div className={`${skeletonButton} `}>
							<Icon path={mdiClipboardPulseOutline} className={`${getSaudeIcon(props.saude)}`} style={{ width: 60 }} />
						</div>
					</Col>
					<Col className={`d-flex flex-column justify-content-center`}>
						<div className={`${props.loading && "skeleton skeleton-text skeleton-text-title"}`}>{props.title}</div>
						<div className={`small fw-light text-muted ${props.loading && "skeleton skeleton-text skeleton-text-title"}`}>{props.dataUltimaChecagem}</div>
					</Col>
					<Col className={`d-flex align-items-center justify-content-end gap-1 flex-wrap`}>
						{props.loading &&
							Array.from({ length: 5 }).map((_, index) => (
								<div className={`${skeletonButton} `}>
									<Icon key={`loading-${index}`} path={mdiSquareRounded} size={0.6} />
								</div>
							))}
						{props.monitoresBads &&
							Number(props.monitoresBads) > 0 &&
							Array.from({ length: Number(props.monitoresBads) }).map((_, index) => <Icon key={`bad-${index}`} path={mdiSquareRounded} size={0.6} className={getSaudeIcon("Bad")} />)}
						{props.monitoresRegulares &&
							Number(props.monitoresRegulares) > 0 &&
							Array.from({ length: Number(props.monitoresRegulares) }).map((_, index) => (
								<Icon key={`regular-${index}`} path={mdiSquareRounded} size={0.6} className={getSaudeIcon("Regular")} />
							))}
						{props.monitoresGoods &&
							Number(props.monitoresGoods) > 0 &&
							Array.from({ length: Number(props.monitoresGoods) }).map((_, index) => <Icon key={`good-${index}`} path={mdiSquareRounded} size={0.6} className={getSaudeIcon("Good")} />)}
					</Col>
					<Col md={1} className="d-flex align-items-center justify-content-center">
						<Icon path={expanded ? mdiChevronUp : mdiChevronDown} size={1} className={`text-muted`} style={{ marginRight: -12 }} />
					</Col>
				</Row>
			</Card.Body>
			<Collapse in={expanded}>
				<div>
					<Card.Body className="py-1 border-top">
						{queryGrupo.isLoading && (
							<div className="text-center py-3">
								<Spinner animation="border" size="sm" />
							</div>
						)}
						{queryGrupo.data?.Result !== 1 && !queryGrupo.isLoading && (
							<Alert variant="secondary" className="text-center mb-0 mt-2">
								{queryGrupo.data?.Message || "Problema ao carregar monitores"}
							</Alert>
						)}
						{queryGrupo.data?.Result === 1 && queryGrupo.data?.Data?.monitores && (
							<Row className="mt-2">
								{ordenarPorSaude(queryGrupo.data.Data.monitores).map((monitor, index) => {
									return (
										<Col md={4} key={index} className="mb-2">
											<div className="d-flex align-items-center gap-2 p-2 bg-light rounded">
												<Icon path={mdiPulse} style={{ width: 40 }} className={getSaudeIcon(monitor.saude)} />
												<div className="flex-grow-1">
													<div className="fw-medium small">{monitor.nome}</div>
													<div className="text-muted small fw-light">{formatarTempoChecagem(monitor.dataUltimaChecagem || "", monitor.ultimaLatencia || "")}</div>
												</div>
											</div>
										</Col>
									);
								})}
								{queryGrupo.data.Data.monitores.length === 0 && (
									<Col md={12}>
										<Alert variant="light" className="text-center mb-0">
											Nenhum monitor neste grupo
										</Alert>
									</Col>
								)}
							</Row>
						)}
					</Card.Body>
				</div>
			</Collapse>
		</Card>
	);
}
